var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoctorFemale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 466.737 466.737",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 41.369,
    y: 370.737,
    style: {
      fill: "#F9BDA0"
    },
    width: 384,
    height: 96
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE3309"
    },
    d: "M133.561,132.154c-1.328-2.672,4.872-7.896,4.872-7.896l75.064-15.368l4.536,104.008l-28.04,32.56"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE3309"
    },
    d: "M333.185,132.154c1.336-2.672-4.864-7.896-4.864-7.896l-75.064-15.368l-4.544,104.008l28.04,32.56"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 185.369,
    y: 186.738,
    style: {
      fill: "#F9BDA0"
    },
    width: 96,
    height: 200
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAA78C"
    },
    points: "281.369,280.145 281.369,186.738 186.345,186.738 234.577,321.273 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M308.329,102.122c0,72.24-36.624,137.616-74.944,137.616s-74.96-65.376-74.96-137.616 s36.64-84.288,74.96-84.288S308.329,29.882,308.329,102.122z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M233.385,17.834c38.32,0,74.944,12.048,74.944,84.288s-36.624,137.616-74.944,137.616"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "189.097,286.313 32.913,334.393 36.593,466.737 229.889,421.353  "
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#FCCCB9"
    },
    points: "32.913,334.393 36.593,466.737 229.889,421.353 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "277.657,286.313 433.833,334.393 430.145,466.737 236.833,421.353 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#EAA78C"
    },
    points: "433.833,334.393 430.145,466.737 236.833,421.353 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5370E"
    },
    d: "M216.409,3.906c0,0,23.256,115.096,117.312,126.744c0,0,3.064-70.688-23-101.504 c-26.08-30.8-66.44-27-66.44-27L216.409,3.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F95130"
    },
    d: "M268.753,3.962c0,0,18.968,90.176-135.672,132.048c0,0-11.784-75.976,18.984-108.528 c30.76-32.56,85.92-27.144,85.92-27.144L268.753,3.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5370E"
    },
    d: "M237.985,0.338l30.768,3.624c0,0,18.968,90.176-135.672,132.048"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.369,
    y: 370.737,
    style: {
      fill: "#6B767C"
    },
    width: 384,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.369,
    y: 386.737,
    style: {
      fill: "#071519"
    },
    width: 384,
    height: 80
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E2F5F7"
    },
    points: "227.385,466.737 179.177,286.785 32.361,332.345 36.593,466.737 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CEEEF2"
    },
    points: "227.385,466.737 179.177,286.785 32.361,332.345 52.593,466.737 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3E4EA"
    },
    points: "227.385,466.737 179.177,286.785 32.361,332.345 84.593,466.737  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C3E4EA"
    },
    points: "239.353,466.737 287.561,286.785 434.377,332.345 430.145,466.737  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8FFFF"
    },
    d: "M386.057,445.817c0,1.128-2.088,2.04-4.664,2.04h-54.672c-2.576,0-4.664-0.912-4.664-2.04l0,0 c0-1.128,2.088-2.04,4.664-2.04h54.672C383.969,443.777,386.057,444.689,386.057,445.817L386.057,445.817z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E2F5F7"
    },
    points: "179.145,287.081 139.369,358.841 178.865,382.602 171.865,428.673 211.369,466.737  221.369,466.737  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E2F5F7"
    },
    points: "287.593,287.081 327.369,358.841 287.865,382.602 294.865,428.673 255.369,466.737  245.369,466.737  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E595E"
    },
    d: "M317.353,387.961c1.952,0,4.016-1.56,4.016-3.496v-99.984c0-21.152-16.512-38.368-37.672-38.368 c-1.92,0-3.152,1.56-3.152,3.496c0,1.92,0.544,3.488,2.464,3.488c17.304,0,30.36,14.08,30.36,31.392v99.992 C313.369,386.401,315.449,387.961,317.353,387.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E595E"
    },
    d: "M182.633,246.114c-21.16,0-37.264,17.216-37.264,38.368v65.832c2.6,0.896,5.4,1.864,8,3.104v-68.936 c0-17.312,12.752-31.392,30.056-31.392c1.912,0,2.16-1.56,2.16-3.488C185.577,247.674,184.553,246.114,182.633,246.114z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#7CB1B5"
    },
    cx: 319.465,
    cy: 390.737,
    r: 8.144
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37A2A5"
    },
    d: "M345.033,415.633c0,14.128-11.472,25.592-25.56,25.592c-14.152,0-25.584-11.472-25.584-25.592 c0-14.112,11.44-25.576,25.584-25.576C333.561,390.057,345.033,401.529,345.033,415.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B8796"
    },
    d: "M301.385,397.553c9.968-9.976,26.176-9.976,36.168,0c9.984,9.984,9.976,26.208,0.016,36.168"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#37A2A5"
    },
    cx: 319.473,
    cy: 415.641,
    r: 13.664
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B8796"
    },
    d: "M309.817,425.289c-5.328-5.312-5.328-13.984,0-19.304c5.328-5.336,14-5.328,19.328-0.008"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37A2A5"
    },
    d: "M169.369,457.977L169.369,457.977l-8.504-88.952c0-7.456-6.832-13.512-14.272-13.512 c-7.472,0-15.88,6.064-15.88,13.512l-9.344,88.952l0,0v-88.952c0-11.296,12.696-20.496,24-20.496c11.312,0,24,9.192,24,20.496 V457.977z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37A2A5"
    },
    d: "M130.769,455.801c0,4.632,1.136,8.392-1.52,8.392c-2.64,0-4.8-3.76-4.8-8.392s2.16-8.4,4.8-8.4 C131.897,447.401,130.769,451.169,130.769,455.801z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#1B8796"
    },
    cx: 125.329,
    cy: 455.777,
    rx: 3.64,
    ry: 4.936
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37A2A5"
    },
    d: "M160.873,455.801c0-4.632-1.128-8.4,1.528-8.4c2.648,0,4.8,3.768,4.8,8.4s-2.152,8.392-4.8,8.392 C159.753,464.193,160.873,460.434,160.873,455.801z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#1B8796"
    },
    cx: 166.329,
    cy: 455.777,
    rx: 3.632,
    ry: 4.944
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 361.369,
    y: 410.737,
    style: {
      fill: "#4E595E"
    },
    width: 8,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.369,
    y: 418.737,
    style: {
      fill: "#4E595E"
    },
    width: 24,
    height: 8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorFemale);
export default __webpack_public_path__ + "static/media/doctor_female.07f1452875f73f80f57ec26f4bd0457f.svg";
export { ForwardRef as ReactComponent };